import clsx from "clsx";
import { useRef } from "react";
import { X } from "react-feather";
import click from "../../../assets/sounds/klick.mp3";
import Sound from "../../Sound";

type Props = {
  onClick: any;
  className?: string;
};

const CloseButton = (props: Props) => {
  const clickSound = useRef(new Sound(click));

  return (
    <button
      className={clsx("p-4 flex ", props.className)}
      onClick={() => {
        props.onClick();
        clickSound.current.play();
      }}
    >
      <X size={35} className="text-white" />
    </button>
  );
};

export default CloseButton;
